import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import { StyledLeadContainer, CreateLeadFooter, StyledSubHeader, StyledGridContainer } from '../../../Components/Styled/index';
import { Box, Button, Typography, Stack, Tooltip, IconButton, FormControlLabel, Switch } from '@mui/material';
import LeadAccordion from '../../../Components/LeadAccordion';
import history from '../../../Utility/history';
import { privateRoutesPath } from '../../../Routes';
import LeadDialog from '../../../Components/LeadDialog';
import BiztantuConfirmDialog from '../../../Components/BiztantuConfirmDialog';

import { useSnackbar } from 'notistack';
import moment from 'moment';
import { createRequestData, customerValidation, dateFormattingForShowing, getEntityColumns, getRequestData, updateRequestData, validateFields } from '../../../Utility/apiHelper';
import { filterActiveTasks } from '../../../Utility/statusUtils';
import DataGridTable from '../../../Components/DataGrid';
import { useSelector, useDispatch } from 'react-redux';
import { requestShowLoader, requestHideLoader } from '../../../Store/Global/action';
import { requestUpdateTaskStatus, requestGetTask, requestCreateCustomerForTask, requestGetSubtasks } from '../../../Store/Tasks/action';
import BiztantuLoader from '../../../Components/Loader';

import { ACTIVITY_TYPE_LABELS, ACTIVE_STATUS, CUSTOMER_STATUS, TASK_PRIORITY, commonTitles, handleValidateCodevalue, whocolumnWidth, idWidth, ownerWidth, statusWidth, STATIC_ENTITY_CONFIG, ADDITIONAL_ATTRIBUTE_FIELDS, CHILD_DATAGRIDTABLE_HEIGHT, ROWS_TO_VIEW_IN_CHILD_TABLE, TaskSystemLookUp, TASK_EXCLUDED_SYSTEM_CODES, I18N_TASK_SUBTASKS, I18N_TASK_CREATE_SUBTASK, I18N_TASK_PARENT_TASK, I18N_TASK_CLOSE_TITLE, I18N_TASK_CLOSE_DESC, statusChipWidth, searchEntity } from '../../../Utility/constant';
import StatusChip from '../../../Components/StatusChip';
import './EditTask.css';
import './Tasks.css';
import useTaskLookups from '../../../Utility/hooks/useTaskLookups';

import CommonEmail from '../../../Components/CommonEmail';
import { requestGetAllCustomers } from '../../../Store/Customer/action';
import DocumentManagement from '../../../Components/DocumentManagement';
import { EntityNote } from '../../../Components/EntityNote';
import SelectBoxWithLabel from '../../../Components/SelectBoxWithLable';
import { useLocation, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import WhoColumnTextfieds from '../../../Components/WhoColumnTextfieds';
import TextFiledWithLabel from '../../../Components/TextFieldWithLabel';
import AuditLogs from '../../Configuration/Audit';

import AutoCompleteComponent from '../../../Components/AutoCompleteComponenet';
import SendNotification from '../../../Components/SendNotification';
import NotificationDialog from '../../../Components/NotificationDialog';
import ReadonlyTextField from '../../../Components/ReadOnlyTextfield';
import MarkunreadIcon from '@mui/icons-material/Markunread';
 import NotificationsIcon from '@mui/icons-material/Notifications';
import TruncatedTextCell from '../../../Components/TruncatedTextCell';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { useIsMobile } from '../../../Utility/hooks/useIsMobile';
import AddBoxIcon from '@mui/icons-material/AddBox';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckIcon from '@mui/icons-material/Check';
import TextDetailDialog from '../../../Components/TextDetailDialog';
import { useCallContext } from '../../../Components/TeleCalling/useCallContext';
import CallIcon from '@mui/icons-material/Call';
import PhoneNumberField from '../../../Components/PhoneNumberField';
import { formatAdditionalAttributesForPayload } from '../../../Utility/payloadFormatter';
import CustomizableFields from '../../../Components/CustomizableFields';
import { FieldWithOpenLink } from '../../../Components/FieldWithOpenLink';
import ActionableDetailCard from '../../../Components/ActionableDetailCard';
import useNavigation from '../../../Utility/hooks/useNavigation';
import useViewMode from '../../../Utility/hooks/useViewMode';
import { useAccordionData } from '../../../Utility/hooks/useAccordionData';

const EditTask = () => {
    const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData);
    const isLoadingProgress = useSelector(state => state?.global.isLoading);
    const ownerlist = useSelector(state => state?.owner?.ownerlist);
    const currentUser = useSelector(state => state?.owner?.currentuser);
    const myTeam = useSelector(state => state?.owner?.Team);

    const telecallingDetails = useSelector(state=> state?.telecalling?.telecallingDetails?.[0]);
    const {
        commonTitles,
        taskPrimaryTypeData,
        taskSecondaryTypeData,
        taskStatusData,
        taskSourceData,
        docType,
        eligibleParentTasks,
    } = useTaskLookups({ includeCustomerDocumentType: true });

    const [isEntityLocked, setIsEntityLocked] = useState(false);
    // Audit Logs accordion — controlled via useAccordionData; fetches lazily on expand
    const auditAccordion = useAccordionData(null, { refetchOnEveryOpen: true, unmountOnExit: true });
    const setIsAuditAccordionExpanded = auditAccordion.setIsExpanded;
    const [taskDetails, setTaskDetails] = useState({});
    const [initialTaskDetails, setInitialTaskDetails] = useState(null);
    const [isRequired, setRequiredValue] = useState(false);
    const [activitiesTableData, setActivitiesTableData] = useState([]);
    const [newActivity, setNewActivity] = useState({
    note: '',
    status: '',
    nextFollowupDate: ''
    });

    const [activityError, setActivityError] = useState({
    note: false
    });
    const { isViewMode, canEdit, isOwner } = useViewMode({
        isAllManage : specificRolePermission?.isAllTaskManage,
        isTeamManage : specificRolePermission?.isTaskTeamManage,
        permission: specificRolePermission?.isTaskManage,
        isEntityLocked,
        ownerId: taskDetails?.selectedOwner?.id,
    });
    const dispatch = useDispatch();
    const location = useLocation();
    const { enqueueSnackbar } = useSnackbar();
    const { taskId } = useParams();
    const customerdropdown = useSelector(state => state?.customer?.customer);
    const subtasks = useSelector(state => state?.tasks?.subtasks || []);
    const statusConflict = useSelector(state => state?.tasks?.statusConflict);

    const [showOpenSubtasksOnly, setShowOpenSubtasksOnly] = useState(true);
    const subtasksAccordion = useAccordionData(
        useCallback(() => {
            if (taskId) {
                setShowOpenSubtasksOnly(true);
                dispatch(requestGetSubtasks(taskId));
            }
        }, [taskId, dispatch]),
        { refetchOnEveryOpen: true }
    );
    const [cascadeConfirm, setCascadeConfirm] = useState({
        open: false,
        openSubtaskCount: 0,
        openSubtaskIds: [],
        pendingPayload: null,
    });
    const { openInNewTab, navigateTo, goBackTo } = useNavigation();
    const inputRef = useRef(null);
    const lastFetchedTaskIdRef = useRef(null); // tracks which taskId has been fetched — prevents double-call when customerdropdown gets a new array reference after customer fetch
    const [canReopenTask, setCanReopenTask] = useState(false);
    const allEntityData = useSelector((state) => state?.customization?.allEntityData || []);

    const taskTextfieldsData = useMemo(() => {
        const data = getEntityColumns(allEntityData, "TASK");
        const sourceData = Object.keys(data).length > 0 ? data: STATIC_ENTITY_CONFIG?.TASK;   
        const { id, ...rest } = sourceData;
            return rest;
    }, [allEntityData]);
    
    // Create Customer dialog state
    const initialState = {
        customerDialog : false,
        followup : false
    }
    const [isOpenDialog, setIsOpenDialog] = useState({
        ...initialState
    });
    const [newCustomerDetail, setNewCustomerDetail] = useState({
        status: 'CUSTOMER_STATUS_ACTIVE',
        title: '',
        firstName: '',
        lastName: '',
        phone: '',
        email: ''
    });
const [customerRequiredValue, setCustomerRequiredValue] = useState({});
const goBack = () => goBackTo(privateRoutesPath.TASKS, searchEntity.task);

    const isMobile = useIsMobile();

const handleChangeActivity = (e) => {
    const { name, value } = e.target;
    setNewActivity(prev => ({
        ...prev,
        [name]: value
    }));
    
    if (name === 'note' && value) {
        setActivityError(prev => ({ ...prev, note: false }));
    }
};

    useEffect(() => {
        if (taskDetails?.status && !newActivity.note) {
            setNewActivity(prev => ({
                ...prev,
                status: taskDetails.status
            }));
        }
    }, [taskDetails?.status]);
    
    useEffect(() => {
        if (statusConflict) {
            setCascadeConfirm(prev => ({
                ...prev,
                open: true,
                openSubtaskCount: statusConflict.openSubtaskCount || 0,
                openSubtaskIds: statusConflict.openSubtaskIds || [],
            }));
        }
    }, [statusConflict]);

    useEffect(() => {
        dispatch(requestGetAllCustomers());
    }, []);

    useEffect(() => {
        if (
            taskId &&
            ownerlist?.length > 0 &&
            customerdropdown?.length > 0 &&
            taskStatusData?.length > 0 &&
            lastFetchedTaskIdRef.current !== taskId
        ) {
            lastFetchedTaskIdRef.current = taskId;
            getTaskDetails();
            getTaskActivities();
        }
    }, [taskId, ownerlist, customerdropdown, taskStatusData]);

    const getTaskDetails = () => {
        dispatch(requestGetTask(
            taskId,
            (task) => {
                const selectedOwner = ownerlist?.find(item => item?.id === task?.ownerId);
                const selectedCustomer = customerdropdown?.find(item => item?.id === task?.customerId);
                const selectedParentTask = eligibleParentTasks?.find(item => item?.id === task?.parentTaskId);
                const taskData = {
                    ...task,
                    showStatus: task?.status,
                    selectedOwner,
                    selectedCustomer,
                    parentTask: selectedParentTask || (task?.parentTaskId ? { id: task.parentTaskId, description: `Task #${task.parentTaskId}` } : null),
                };
                const isDealClosed = taskStatusData?.find(item => item?.name === task?.status);
                if (isDealClosed?.systemLookupCode?.name === TaskSystemLookUp.TASK_STATUS_CLOSED || isDealClosed?.systemLookupCode?.name === TaskSystemLookUp.TASK_STATUS_CANCELLED) {
                    setIsEntityLocked(true);
                    setCanReopenTask(true);
                } else {
                    setCanReopenTask(false);
                }
                setTaskDetails(taskData);
                setInitialTaskDetails(taskData);
            },
            () => {
                enqueueSnackbar(handleValidateCodevalue(internationalise, 'COMMON_PLEASE_TRY_AGAIN'), { variant: 'error' });
            }
        ));
    }

    const getTaskActivities = useCallback(async () => {
        try {
            const url = `${process.env.REACT_APP_BASE_URL}task-activities/task/${taskId}`;
            const response = await getRequestData(url);
            
            if (response?.data) {
                const formattedActivities = response.data.map((activity) => ({
                    ...activity,
                    id: activity.id,
                    note: activity.note,
                    nextFollowupDate: activity.nextFollowupDate ? moment(activity.nextFollowupDate).format('MM/DD/YYYY') : "",
                    nextFollowupDateRaw: activity.nextFollowupDate ?? null,
                    createdAt: activity.createdAt ? moment(activity.createdAt).format('MM/DD/YYYY') : "",
                    createdByName: activity.createdByName,
                    activityType: activity.activityType ?? null,
                    recipients: activity.recipients ?? null,
                    createdAtRaw: activity.createdAt ?? null,  
                    callStatus: activity.callStatus ?? null,
                    callDuration: activity.callDuration ?? null,
                }));
                setActivitiesTableData(formattedActivities);
            }
        } catch (error) {
            console.error('Error fetching activities:', error);
        }
    }, [taskId]);

    const handleOnChange = (event) => {
        const { name, value } = event?.target;
        setTaskDetails(prev => ({
            ...prev,
            [name]: value
        }));
    }

    const handleSelectOwner = (event, Owner) => {
        setTaskDetails(prev => ({
            ...prev,
            selectedOwner: Owner,
            ownerId: Owner?.id
        }));
    }

    const handleSelectCustomer = (event, Customer) => {
        setTaskDetails(prev => ({
            ...prev,
            selectedCustomer: Customer,
        }));
    }

    const validateTask = () => {
        if (!taskDetails?.description || !taskDetails?.ownerId || !taskDetails?.primaryType || 
            !taskDetails?.secondaryType || !taskDetails?.status) {
            return false;
        }
        return true;
    }


    const handleAuditAccordionChange = (_, isExpanded) => {
        setIsAuditAccordionExpanded(isExpanded);
    };

    const handleUpdateTask = async (value = false) => {
        if (JSON.stringify(initialTaskDetails) === JSON.stringify(taskDetails)) {
            if(value === true){
                goBack();
            } else {
                enqueueSnackbar(handleValidateCodevalue(internationalise, "COMMON_NO_DATA_CHANGED"), { variant: "info" });
            }
            return;
        }

        const {errors,hasError} = validateFields(taskTextfieldsData, taskDetails);
        if(hasError) {
            setRequiredValue(errors);
            enqueueSnackbar(handleValidateCodevalue(internationalise, "COMMON_MSG_MANDATORY_FIELDS"), { variant: "error" });
            return;
        }

        dispatch(requestShowLoader());
        try {
            const payload = formatAdditionalAttributesForPayload(
                {
                   ...taskDetails,
                    customerId: taskDetails?.selectedCustomer?.id,
                    parentTaskId: taskDetails?.parentTaskId || null,
                },
                ADDITIONAL_ATTRIBUTE_FIELDS
            );

            const url = `${process.env.REACT_APP_BASE_URL}tasks/${taskId}`;
            const response = await updateRequestData(payload, url);

            if (response?.status === 200) {
                dispatch(requestHideLoader());
                enqueueSnackbar(handleValidateCodevalue(internationalise, 'COMMON_UPDATED_SUCCESSFULLY'), { variant: 'success' });
                getTaskDetails(); 
                setIsAuditAccordionExpanded(false);
            if(value == true){
                goBack();
            }
            }
        } catch (error) {
            dispatch(requestHideLoader());
            if (error?.response?.status !== 401) {
                enqueueSnackbar(handleValidateCodevalue(internationalise, error?.response?.data?.message || "COMMON_PLEASE_TRY_AGAIN"), { variant: 'error' });
            }
        }
    }


  
 const handleSaveActivity = () => {
        if (!newActivity.note || newActivity.note.trim() === '' || !newActivity?.status) {
            setActivityError({
                ...activityError,
                note: true,
                status : true
            });
            enqueueSnackbar(handleValidateCodevalue(internationalise, "COMMON_MSG_MANDATORY_FIELDS"), { variant: "error" });
            return;
        }

        const payload = {
            taskId: parseInt(taskId),  
            status: newActivity.status,
            note: newActivity.note,
        };
        if (newActivity.nextFollowupDate) {
            payload.nextFollowupDate = newActivity.nextFollowupDate;
        }

        handleAddActivityMethod(payload);
        
        setActivityError({
            ...activityError,
            note: false,
            status : false
        });
    };

const handleEmailSent = () => {
    getTaskDetails();
    getTaskActivities();
    setIsAuditAccordionExpanded(false);
};


const handleAddActivityMethod = async (payload) => {
    try {
        dispatch(requestShowLoader());

        const url = `${process.env.REACT_APP_BASE_URL}task-activities/create`;
        const response = await createRequestData(payload, url);
        if (response?.status >= 200 && response?.status <= 300) {
            enqueueSnackbar(handleValidateCodevalue(internationalise, 'COMMON_ADDED_SUCCESSFULLY'), { variant: 'success' });
            setNewActivity({
                note: '',
                status: payload?.status || '',
                nextFollowupDate: ''
            });
            if (isOpenDialog?.followup) {
                setIsOpenDialog({
                    ...initialState
                });
            }
            getTaskDetails();
            getTaskActivities();
            if (taskId) {
                dispatch(requestGetSubtasks(taskId));
            }
            setIsAuditAccordionExpanded(false);
        } else if (response?.propererror?.status === 409 || response?.status === 409) {
            const conflictData = response?.propererror?.data || response?.data;
            setCascadeConfirm({
                open: true,
                openSubtaskCount: conflictData?.openSubtaskCount || 0,
                openSubtaskIds: conflictData?.openSubtaskIds || [],
                pendingPayload: payload,
                isActivity: true,
            });
        } else {
            const errorMessage = response?.propererror?.data?.message || response?.data?.message || "COMMON_PLEASE_TRY_AGAIN";
            enqueueSnackbar(handleValidateCodevalue(internationalise, errorMessage), { variant: 'error' });
        }
    } catch (error) {
        if (error?.response?.status === 409) {
            const conflictData = error?.response?.data;
            setCascadeConfirm({
                open: true,
                openSubtaskCount: conflictData?.openSubtaskCount || 0,
                openSubtaskIds: conflictData?.openSubtaskIds || [],
                pendingPayload: payload,
                isActivity: true,
            });
        } else if (error?.response?.status !== 401) {
            enqueueSnackbar(handleValidateCodevalue(internationalise, "COMMON_PLEASE_TRY_AGAIN"), { variant: 'error' });
        }
    } finally {
        dispatch(requestHideLoader());
    }
};

const handleViewCustomer = (id) => () => {
    navigateTo(`${privateRoutesPath.EDIT_CUSTOMER}/${id}`,
        { 
            isViewMode: true,
        },
        searchEntity?.task);
}


    const activityColumns = [
     
        {
            field: 'note',
            headerName: handleValidateCodevalue(internationalise, 'TASK_ACTIVITY_NOTE'),
            flex: 3,
            renderCell: (params) => (    
                <TruncatedTextCell 
                    text={handleValidateCodevalue(internationalise, params.value)}
                    dialogTitle="TASK_ACTIVITY_NOTE" 
                    stripHtml={true}
                    activityType={params.row.activityType}
                    recipients={params.row.recipients}
                    createdAt={params.row.createdAtRaw}
                    callStatus={params.row.callStatus}
                    callDuration={params.row.callDuration}
                />
            )
        },
   { 
            field: 'activityType', 
            headerName: handleValidateCodevalue(internationalise, 'COMMON_DETAILS') || 'Details',
            flex: 1,
            editable: false,
            renderCell: (params) => {
                return <span>{params.row.activityType ? ACTIVITY_TYPE_LABELS[params.row.activityType] || params.row.activityType : 'Note'}</span>;
            } 
        },

        {
            field: 'status',
            headerName: handleValidateCodevalue(internationalise, 'TASK_EDIT_STATUS'),
            flex: 1,
             renderCell: (cellValues) => {
                            return  <span>{handleValidateCodevalue(internationalise, cellValues?.row?.status)}</span>;
                          } 
        },
        {
            field: 'updatedByName',
            headerName: handleValidateCodevalue(internationalise, 'COMMON_UPDATED_BY'),
            flex: 1,
            editable:false
        },
                
        {
            field: 'createdAt',
            headerName: handleValidateCodevalue(internationalise, 'TASK_ACTIVITY_DATE'),
            flex: 1,
            minWidth: whocolumnWidth
        },
        {
            field: 'nextFollowupDate',
            headerName: handleValidateCodevalue(internationalise, 'TASK_NEXT_FOLLOWUP_DATE'),
            flex: 1,
            minWidth: 150
        },


    ]
    
const customerProductColumns = [
    {
        field: 'productName',
        headerName: handleValidateCodevalue(internationalise, 'COMMON_PROD_NAME'),
        flex: 1,
        minWidth: 150,
        editable: false
    },
    {
        field: 'sellingDate',
        headerName: handleValidateCodevalue(internationalise, 'COMMON_PROD_SELLING_DATE'),
        flex: 0.8,
        minWidth: 120,
        editable: false,
        valueGetter: ({ value }) => value && moment(value).format('MM/DD/YYYY'),
        
    },
    {
        field: 'quantity',
        headerName: handleValidateCodevalue(internationalise, 'COMMON_PROD_QTY'),
        flex: 0.5,
        minWidth: 100,
        editable: false,
       
    },
    {
        field: 'unitOfMeasurement',
        headerName: handleValidateCodevalue(internationalise, 'COMMON_PROD_UOM'),
        flex: 0.5,
        minWidth: 80,
        editable: false,
       valueGetter:({value})=>{
        if(!value){
          return ""
        }
          return handleValidateCodevalue(internationalise,value)
        }
    },
    {
        field: 'totalPrice',
        headerName: handleValidateCodevalue(internationalise, 'COMMON_PROD_TP'),
        flex: 0.7,
        minWidth: 120,
        editable: false,
        
    }
];


const handleOpenNotificationPopup = useCallback(async (isWhatsapp = false,channel)=> {
setIsOpenNotificationDialog({
        selectedDetails: [taskDetails.customerDetails?.id], 
        isOpen: true,
        isWhatsapp : isWhatsapp,
        channel : channel
    });
}, [taskDetails]);



const [isOpenNotificationDialog,setIsOpenNotificationDialog] = useState({
    selectedTemplate : null,
    isOpen : false,
    templates : [],
    isWhatsapp : false
})
const [openNotifyBox, setOpenNotifyBox] = useState({
  message: "",
  open: false,
  ownerName: "",
  required: false,
  destinationId: null,
  receiverId: null
});
const handleOpenNotifyBox = (allUsersFlag) => {
    const Owner = ownerlist?.find(item => item?.id === taskDetails?.ownerId);
    const ownerName = allUsersFlag || `${Owner?.firstName} ${Owner?.lastName}` 
    const url = allUsersFlag ? 
    `${process.env.REACT_APP_BASE_URL}notification/all-task-owners`
    : `${process.env.REACT_APP_BASE_URL}notification`;
  setOpenNotifyBox({
    url : url,
    open: true,
    destinationId: taskDetails?.id,
    receiverId: Owner?.id,
    ownerName: ownerName
  });
};

    const handleCloseDialog = () => {
        setOpenNotifyBox({
            message: "",
            open: false,
            ownerName: "",
            required: false,
            destinationId: null,
            receiverId: null
        });
    };

    const displayedSubtasks = useMemo(() =>
        showOpenSubtasksOnly
            ? filterActiveTasks(subtasks, taskStatusData, TASK_EXCLUDED_SYSTEM_CODES)
            : subtasks,
        [subtasks, taskStatusData, showOpenSubtasksOnly]
    );

    const handleCreateSubtask = useCallback(() => {
        const latestActivity = activitiesTableData?.[0];
        const parentNextFollowupDate = latestActivity?.nextFollowupDateRaw
            ? moment(latestActivity.nextFollowupDateRaw).format('YYYY-MM-DD')
            : (latestActivity?.nextFollowupDate ? moment(latestActivity.nextFollowupDate, ['MM/DD/YYYY', 'YYYY-MM-DD', moment.ISO_8601]).format('YYYY-MM-DD') : '');

        const parentCreatedAt = taskDetails?.createdAt
            ? moment(taskDetails.createdAt).format('YYYY-MM-DD')
            : '';

        navigateTo(privateRoutesPath.TASKS_CREATE, {
            parentTaskId: taskDetails?.id,
            parentTaskDetail: {
                ...taskDetails,
                nextFollowupDate: parentNextFollowupDate,
                parentNextFollowupDate,
                parentCreatedAt,
            },
            parentNextFollowupDate,
            parentCreatedAt,
            },
        searchEntity.task // ← pass entity → sets preserveSearch=true
        );
    }, [taskDetails, activitiesTableData, navigateTo]);


const handleViewTask = (id, isView) => () => {
    openInNewTab(
        `${privateRoutesPath?.EDIT_TASK}/${id}`
    );
};
    const subtaskColumns = useMemo(() => [
        {
            field: 'id',
            headerName: handleValidateCodevalue(internationalise, 'TASK_SEARCH_TASK_ID') || 'Task ID',
            flex: 1,
            minWidth: idWidth || 100,
            renderCell: (params) => {
                    const raw = params.row;
                    const customer = raw.customerDetails;
                    const customerName = customer
                        ? `${customer.firstName || ''} ${customer.lastName || ''}`.trim()
                        : (raw.customerName || '');
                    const latestNote = raw.taskActivity?.note || raw.latestActivityNote || '';
                    const nextFollowupDate = raw.taskActivity?.nextFollowupDate || raw.nextFollowupDate;

                    // Build the same shape ActionableDetailCard expects
                    const item = {
                        rawId: raw.id,
                        rawItem: {
                            ...raw,
                            customerName: customerName,
                            latestNote: latestNote,
                            totalValue: customer?.totalValue,
                        },
                        startDate: dateFormattingForShowing(raw.createdAt),
                        endDate: dateFormattingForShowing(nextFollowupDate),
                        rawStatus: raw.status,
                        systemLookup: raw.systemLookUpCodeStatus
                    };
            
                    return (
                        <Tooltip
                            title={
                                <ActionableDetailCard
                                    item={item}
                                    isLead={false}
                                    internationalise={internationalise}
                                     onClick={handleViewTask(raw.id, true)} 
                                />
                            }
                            arrow
                            placement="top"
                            componentsProps={{
                                tooltip: { className: 'actionables-calendar__tooltip' }
                            }}
                        >
                            <span
                                onClick={handleViewTask(raw.id, true)}
                                className="subtask-id-link"
                            >
                                {raw.id}
                            </span>
                        </Tooltip>
                    );
                }
        },
        {
            field: 'description',
            headerName: handleValidateCodevalue(internationalise, 'TASK_EDIT_DESCRIPTION') || 'Description',
            flex: 2,
            renderCell: (params) => (
                <TruncatedTextCell text={params.value} dialogTitle="TASK_EDIT_DESCRIPTION" stripHtml />
            ),
        },
        {
            field: 'ownerId',
            headerName: handleValidateCodevalue(internationalise, 'TASK_SEARCH_OWNER') || 'Owner',
            flex: 1,
            minWidth: ownerWidth || 150,
            valueGetter: ({ value }) => {
                const owner = ownerlist?.find(o => o.id === value);
                return owner ? `${owner.firstName} ${owner.lastName}` : '';
            },
        },
        {
            field: 'status',
            headerName: handleValidateCodevalue(internationalise, 'TASK_EDIT_STATUS') || 'Status',
            flex: 1,
            minWidth: statusChipWidth || 120,
            editable: false,
            renderCell: (params) => (
                <StatusChip
                    isLead={false}
                    systemLookup={params?.row?.systemLookUpCodeStatus}
                    status={params.row.status}
                    internationalise={internationalise}
                />
            )
        },
    ], [internationalise, ownerlist]);

    const handleSubtasksAccordionChange = subtasksAccordion.onAccordionChange;

    const handleCascadeConfirm = useCallback(() => {
        if (!cascadeConfirm.pendingPayload) return;
        if (cascadeConfirm.isActivity) {
            const cascadePayload = {
                ...cascadeConfirm.pendingPayload,
                cascadeSubtasks: true
            };
            setCascadeConfirm({ open: false, openSubtaskCount: 0, openSubtaskIds: [], pendingPayload: null, isActivity: false });
            handleAddActivityMethod(cascadePayload);
            return;
        }

        const cascadePayload = Array.isArray(cascadeConfirm.pendingPayload)
            ? cascadeConfirm.pendingPayload.map(t => ({ ...t, cascadeSubtasks: true }))
            : [{ ...cascadeConfirm.pendingPayload, cascadeSubtasks: true }];

        dispatch(requestUpdateTaskStatus(
            cascadePayload,
            () => {
                enqueueSnackbar(handleValidateCodevalue(internationalise, 'COMMON_UPDATED_SUCCESSFULLY'), { variant: 'success' });
                getTaskDetails();
                if (taskId) {
                    dispatch(requestGetSubtasks(taskId));
                }
                setCascadeConfirm({ open: false, openSubtaskCount: 0, openSubtaskIds: [], pendingPayload: null, isActivity: false });
            },
            (error) => {
                enqueueSnackbar(handleValidateCodevalue(internationalise, error?.response?.data?.message || "COMMON_PLEASE_TRY_AGAIN"), { variant: 'error' });
                setCascadeConfirm({ open: false, openSubtaskCount: 0, openSubtaskIds: [], pendingPayload: null, isActivity: false });
            }
        ));
    }, [cascadeConfirm, dispatch, taskId, internationalise]);

    const handleReopenTask = () => {
        const openStatus = taskStatusData?.find(item => item?.systemLookupCode?.name === TaskSystemLookUp.TASK_STATUS_OPEN);

        if (!openStatus) {
            enqueueSnackbar(handleValidateCodevalue(internationalise, "COMMON_PLEASE_TRY_AGAIN"), { variant: 'error' });
            return;
        }

        const tasksToUpdate = [{
            id: parseInt(taskId),
            status: openStatus?.name
        }];

        dispatch(requestUpdateTaskStatus(
            tasksToUpdate,
            () => {
                enqueueSnackbar(handleValidateCodevalue(internationalise, 'TASK_REOPENED_SUCCESSFULLY'), { variant: 'success' });
                getTaskDetails();
                setIsAuditAccordionExpanded(false);
                setIsEntityLocked(false)
            },
            (error) => {
                enqueueSnackbar(handleValidateCodevalue(internationalise, error?.response?.data?.message || "COMMON_PLEASE_TRY_AGAIN"), { variant: 'error' });
            }
        ));
    };

    const handleOpenCreateCustomer = () => {
        setNewCustomerDetail({
            status: 'CUSTOMER_STATUS_ACTIVE',
            title: '',
            firstName: '',
            lastName: '',
            phone: '',
            email: taskDetails?.senderEmail || ''
        });
        setCustomerRequiredValue({});
        setIsOpenDialog({
            ...isOpenDialog,
            customerDialog : true
        });
    };

    const handleCloseCreateCustomer = () => {
        setIsOpenDialog({
            ...initialState
        });
        setCustomerRequiredValue({});
    };

    const handleChangeNewCustomer = (event) => {
        setNewCustomerDetail(prev => ({
            ...prev,
            [event.target.name]: event.target.value
        }));
    };

    const handleSaveNewCustomer = () => {
        if (customerValidation(newCustomerDetail)) {
            dispatch(requestCreateCustomerForTask(
                taskId,
                newCustomerDetail,
                (createdCustomer) => {
                    // Backend atomically created the customer and linked it to the task
                    enqueueSnackbar(handleValidateCodevalue(internationalise, 'COMMON_CREATED_SUCCESSFULLY'), { variant: 'success' });
                    setIsOpenDialog({
                        ...initialState
                    });
                    setCustomerRequiredValue({});
                    // Set customer directly from API response — avoids race condition where 
                    // getTaskDetails() can't find the new customer in the stale customerdropdown
                    setTaskDetails(prev => ({
                        ...prev,
                        selectedCustomer: createdCustomer,
                        customerId: createdCustomer?.id,
                    }));
                    setInitialTaskDetails(prev => ({
                        ...prev,
                        selectedCustomer: createdCustomer,
                        customerId: createdCustomer?.id,
                    }));
                    // Refresh dropdown silently in background so future lookups work
                    dispatch(requestGetAllCustomers());
                    setIsAuditAccordionExpanded(false);
                },
                (error) => {
                    const errorMsg = error?.data?.message || error?.message || 'COMMON_PLEASE_TRY_AGAIN';
                    enqueueSnackbar(handleValidateCodevalue(internationalise, errorMsg), { variant: 'error' });
                }
            ));
        } else {
            enqueueSnackbar(handleValidateCodevalue(internationalise, 'COMMON_MSG_MANDATORY_FIELDS'), { variant: 'error' });
            setCustomerRequiredValue({
                title: true,
                firstName: true,
                lastName: true,
                status: true,
                phone: true,
                email: true
            });
        }
    };
    
const renderValuesOnCard = [
    { field: "status", useChip : true,left : true },
    { field: "updatedBy",useAvatar : true,right : true },
    { field: "createdAt",useLabel : "TASK_ACTIVITY_DATE" ,type : "date" },
    { field: "nextFollowupDate",useLabel : "TASK_NEXT_FOLLOWUP_DATE" ,type : "date" },
    { field: "note",stripHtml:true,truncate : true, },
]

const renderValuesOnCardIfCustomer = [
    { field: "quantity",useLabel : "COMMON_PROD_QTY"  },
    { field: "sellingDate",useLabel : "COMMON_PROD_SELLING_DATE", type : "date"  },
    { field: "unitOfMeasurement",useLabel:"COMMON_PROD_UOM" },
    { field: "totalPrice",useLabel : "COMMON_PROD_TP",type : "currency" }
]

const { startOutgoingCall, registerPageCallHint, clearPageCallHint } = useCallContext();

useEffect(() => {
  if (taskDetails?.selectedCustomer?.phone) {
    registerPageCallHint({
      ClientId: currentUser?.client?.id,
      userId: currentUser?.userId,
      TaskId: taskId,
      phone: taskDetails?.selectedCustomer?.phone,
      phoneCountryCode: taskDetails?.selectedCustomer?.phoneCountryCode || "+91",
      title: handleValidateCodevalue(internationalise, "COMMON_NOTIFY_CUSTOMER") || "Notify Customer",
      onCallActivityReady: () => getTaskActivities(),
    });
  } else {
    clearPageCallHint();
  }

  return () => clearPageCallHint();
}, [taskDetails?.selectedCustomer?.phone, taskDetails?.selectedCustomer?.phoneCountryCode, taskId, currentUser, internationalise, registerPageCallHint, clearPageCallHint, getTaskActivities]);
    const activityForm = (
        <>
                    <TextFiledWithLabel
                className={`${isMobile ? '' : 'ml-20 '}edit-task-activity-note`}
                id="activity-note"
                label={handleValidateCodevalue(internationalise, "TASK_EDIT_ACTIVITY_NOTE")}
                required={true}
                name="note"
                value={newActivity.note}
                handleOnChange={handleChangeActivity}
                error={newActivity.note ? false : activityError.note}
            />
            <TextFiledWithLabel
                className={`${isMobile ? 'mt-15 ' : ''}edit-task-activity-date`}
                id="next-followup-date"
                type="date"
                name="nextFollowupDate"
                value={newActivity.nextFollowupDate}
                label={handleValidateCodevalue(internationalise, "TASK_NEXT_FOLLOWUP_DATE")}
                handleOnChange={handleChangeActivity}
            />
             <SelectBoxWithLabel
                className={`${isMobile ? 'mt-15 ' : ''}edit-task-activity-status`}
                required={true}
                disabled={isViewMode}
                name="status"
                value={newActivity?.status || ''}
                label={handleValidateCodevalue(internationalise, "TASK_EDIT_STATUS")}
                error={newActivity?.status ? false : activityError?.status}
                optionMenuItem={taskStatusData}
                handleOnChange={handleChangeActivity}
                isStatic={false}
                ownerdropdown={false}
            />
            </>
    )
    
    const [isOpenActivityPopup,setIsOpenActivityPopup] = useState({
        open : false,
        selectedCard : null
    })
    const handleCardClick = (card) => {
      setIsOpenActivityPopup({
        open: true,
        selectedCard: card
      });
    };
    const handleTelecallingClose = useCallback(() => {
        getTaskActivities();
    }, [getTaskActivities]);

    const configLabels = STATIC_ENTITY_CONFIG?.TASK

    return (
        <BiztantuLoader open={isLoadingProgress} isChildren={true}>
            <Box className={isMobile ?  'globalBoxMobile' : 'globalBox'}>
                {/* <StyledSubHeader>
                    {handleValidateCodevalue(internationalise, 'TASK_EDIT_TASK_DETAILS')}
                </StyledSubHeader> */}
                <LeadAccordion
                    label={`${handleValidateCodevalue(internationalise, 'TASK_EDIT_TASK_DETAILS')} - ${taskId}`}
                >
                {!isViewMode && (
                    
                    <Box className = "mt-15 mb-10">
                        <Button className='edit-primary' variant="outlined" onClick={handleUpdateTask}>
                            {handleValidateCodevalue(internationalise, "COMMON_SAVE")}
                        </Button>
                            <Button className='edit-primary btn-space' variant="outlined" onClick={() => handleUpdateTask(true)}>
                            {handleValidateCodevalue(internationalise, "COMMON_SAVE_AND_EXIT")}
                        </Button>
                    </Box>
                    )}
                {/* Task ID and GUID Row (Always Read-only) */}
                <StyledGridContainer>
                    <TextFiledWithLabel
                        name="id"
                        disabled
                        value={taskDetails?.id || ''}
                        label={handleValidateCodevalue(internationalise, configLabels?.id?.label)}
                    />
                    <FieldWithOpenLink
                        id = {initialTaskDetails?.parentTask?.id}
                        href={
                            initialTaskDetails?.parentTask?.id
                                ? `${privateRoutesPath?.EDIT_TASK}/${initialTaskDetails?.parentTask?.id}`
                                : null
                        }
                        tooltip={handleValidateCodevalue(
                            internationalise,
                            "TASK_EDIT_OPEN_TASK"
                        )}
                    >
                    <AutoCompleteComponent
                        disabled={isViewMode}
                        optionSet={(eligibleParentTasks || []).filter(t => t.id !== taskDetails?.id)}
                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                        value={taskDetails?.parentTask || null}
                        name="parentTaskId"
                        placeholder={handleValidateCodevalue(internationalise, I18N_TASK_PARENT_TASK) || 'Parent Task'}
                        label={handleValidateCodevalue(internationalise, I18N_TASK_PARENT_TASK) || 'Parent Task'}
                        getOptionLabel={(option) =>
                            option ? `${option.id} - ${(option.description || '').substring(0, 60)}` : ''
                        }
                        onChange={(_, task) => {
                            setTaskDetails(prev => ({
                                ...prev,
                                parentTaskId: task?.id || null,
                                parentTask: task || null,
                            }));
                        }}
                    />
                    </FieldWithOpenLink>
                    <FieldWithOpenLink
                        id = {initialTaskDetails?.selectedCustomer?.id}
                        href={
                            initialTaskDetails?.selectedCustomer?.id
                                ? `${privateRoutesPath.EDIT_CUSTOMER}/${initialTaskDetails?.selectedCustomer?.id}`
                                : null
                        }
                        tooltip={handleValidateCodevalue(
                            internationalise,
                            "TASK_EDIT_OPEN_CUSTOMER"
                        )}
                    >
                     <AutoCompleteComponent
                        isOwner={true}
                        disabled={isViewMode}
                        optionSet={customerdropdown || []}
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        value={taskDetails?.selectedCustomer || null}
                        name="customerId"
                        placeholder={handleValidateCodevalue(internationalise, configLabels?.selectedCustomer?.label)}
                        label={handleValidateCodevalue(internationalise, configLabels?.selectedCustomer?.label)}
                        onChange={handleSelectCustomer}
                    />
                    </FieldWithOpenLink>
                     <AutoCompleteComponent
                        isOwner={true}
                        isViewMode={isViewMode}
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        optionSet={(specificRolePermission?.isAllTaskManage ? ownerlist
                            : specificRolePermission?.isTaskTeamManage ? myTeam
                            : [{
                                firstName: `${currentUser?.firstname}`,
                                lastName: `${currentUser?.lastname}`,
                                id: currentUser?.userId,
                            }]) || []}
                        value={taskDetails?.selectedOwner || null}
                        disabled={isViewMode || !(specificRolePermission?.isAllTaskManage || specificRolePermission?.isTaskTeamManage)}
                        name="selectedOwner"
                        placeholder={handleValidateCodevalue(internationalise, configLabels?.selectedOwner?.label)}
                        error={taskDetails?.selectedOwner ? false : isRequired?.selectedOwner}
                        required={true}
                        label={handleValidateCodevalue(internationalise, configLabels?.selectedOwner?.label)}
                        onChange={handleSelectOwner}
                    />
                    <TextFiledWithLabel
                        disabled
                        value={handleValidateCodevalue(internationalise,taskDetails?.showStatus || '')}
                        label={handleValidateCodevalue(internationalise, configLabels?.status?.label)}

                    />
                    <SelectBoxWithLabel
                        select
                        required={true}
                        disabled={isViewMode}
                        name="primaryType"
                        value={taskDetails?.primaryType || ''}
                        label={handleValidateCodevalue(internationalise, configLabels?.primaryType?.label)}
                        error={taskDetails?.primaryType ? false : isRequired?.primaryType}
                        optionMenuItem={taskPrimaryTypeData}
                        handleOnChange={handleOnChange}
                        isStatic={false}
                        ownerdropdown={false}
                    />
                    <SelectBoxWithLabel
                        select
                        required={true}
                        disabled={isViewMode}
                        name="secondaryType"
                        value={taskDetails?.secondaryType || ''}
                        label={handleValidateCodevalue(internationalise, configLabels?.secondaryType?.label)}
                        error={taskDetails?.secondaryType ? false : isRequired?.secondaryType}
                        optionMenuItem={taskSecondaryTypeData}
                        handleOnChange={handleOnChange}
                        isStatic={false}
                        ownerdropdown={false}
                    />
                    
                    {taskTextfieldsData?.source?.visibility && 
                    <SelectBoxWithLabel
                        select
                        disabled={isViewMode}
                        name="source"
                        required = {taskTextfieldsData?.source?.mandatory}
                        error={taskDetails?.source ? false : !!isRequired?.source}
                        value={taskDetails?.source || ''}
                        label={handleValidateCodevalue(internationalise, configLabels?.source?.label)}
                        optionMenuItem={taskSourceData}
                        handleOnChange={handleOnChange}
                        isStatic={false}
                        ownerdropdown={false}
                    />
                    }
                    <SelectBoxWithLabel
                        select
                        disabled={isViewMode}
                        name="priority"
                        value={taskDetails?.priority || ''}
                        label={handleValidateCodevalue(internationalise, configLabels?.priority?.label)}
                        optionMenuItem={TASK_PRIORITY}
                        handleOnChange={handleOnChange}
                        isStatic={true}
                        ownerdropdown={false}
                    />
                    
                </StyledGridContainer>
                <CustomizableFields
                    isViewMode = {isViewMode}
                    CUSTOMIZABLE_FIELDS={ADDITIONAL_ATTRIBUTE_FIELDS}
                    entity = "TASK"
                    config={taskTextfieldsData}
                    values={taskDetails}
                    setValues={setTaskDetails}
                    handleOnChange={handleOnChange}
                    errors={isRequired}
                />
                <StyledLeadContainer>
                    <TextFiledWithLabel
                        label={handleValidateCodevalue(internationalise, 'TASK_EDIT_DESCRIPTION')}
                        name="description"
                        inputRef={inputRef}
                        required={true}
                        disabled={isViewMode}
                        error={taskDetails?.description ? false : isRequired?.description}
                        value={taskDetails?.description || ''}
                        handleOnChange={handleOnChange}
                        multiline
                        rows={1}
                        className="edit-task-description"
                    />
                </StyledLeadContainer>
                <WhoColumnTextfieds
                    entityDetails={taskDetails}
                />
               

                <StyledSubHeader>
                    {handleValidateCodevalue(internationalise, 'TASK_EDIT_SENDER_DETAILS')}
                </StyledSubHeader>
                <StyledLeadContainer>
                    <ReadonlyTextField
                        label={handleValidateCodevalue(internationalise, "TASK_EDIT_SENDER_EMAIL")}
                        name="senderEmail"
                        value={taskDetails?.senderEmail}
                    />

                    <ReadonlyTextField
                        label={handleValidateCodevalue(internationalise, "TASK_EDIT_TO_EMAIL")}
                        name="toEmail"
                        value={taskDetails?.toEmail}
                    />

                    <ReadonlyTextField
                        label={handleValidateCodevalue(internationalise, "TASK_EDIT_CC_EMAIL")}
                        name="ccEmail"
                        value={taskDetails?.ccEmail}
                    />

                    {(!isViewMode && !taskDetails?.customerId && taskDetails?.senderEmail &&!isMobile) ? (
                        <Button
                            className='biztantu-sec-btn edit-task-btn-create-customer'
                            variant="contained"
                            size="large"
                            onClick={handleOpenCreateCustomer}
                        >
                            {handleValidateCodevalue(internationalise, 'TASK_CREATE_CUSTOMER')}
                        </Button>
                    ) : (
                        <TextFiledWithLabel className="task-hidden-field" />
                    )}
                </StyledLeadContainer>
                {/* Special Note */}
                <EntityNote
                    isViewMode={isViewMode}
                    entityDetails={taskDetails}
                    name="specialNote"
                    onChange={handleOnChange}
                    headingLabel={handleValidateCodevalue(internationalise, "COMMON_SPECIAL_NOTE")}
                />

                {/* Who Columns (Always Read-only) */}

 </LeadAccordion>

             {/* Task Activities Accordion */}
<LeadAccordion
    label={handleValidateCodevalue(internationalise, 'TASK_EDIT_ACTIVITIES')}
    defaultOpen={true}
>
    {!isViewMode && (
        <StyledLeadContainer className='mb-10 edit-task-activity-container'>
        {!isMobile &&
        <StyledLeadContainer className='icon-Container edit-task-activity-icon-container'>
            
            {activityForm}
    <Button
        className='biztantu-sec-btn edit-task-btn-add'
        variant="contained" 
        size="large" 
        onClick={handleSaveActivity}
    >
        {handleValidateCodevalue(internationalise, "COMMON_ADD")}
    </Button>
    </StyledLeadContainer>}
        <StyledLeadContainer className="edit-task-mobile-btn-row">
        {isMobile &&
            <Stack 
                className='icon-Container'
                padding = {isMobile ? "0px 0px": "0px 16px"}
                bgcolor={"#F4F9FE"}
                display="flex" 
                gap = {1}
                justifyContent="flex-start"
                flexDirection="row" 
            >
      <Tooltip title={handleValidateCodevalue(internationalise, "COMMON_ADD")}>
                            <IconButton
                             onClick={() => setIsOpenDialog({
                    ...isOpenDialog,
                        followup: true
                })}
                             >
                            <AddBoxIcon className='followup-icons'
                            />
                            </IconButton>
                        </Tooltip> 
            </Stack>
            }
            {isMobile && isOpenDialog?.followup && (
                <LeadDialog
                    open={isOpenDialog?.followup}
                    handleClose={() => setIsOpenDialog({...isOpenDialog, followup: false})}
                    title={handleValidateCodevalue(internationalise,"TASK_EDIT_ACTIVITIES")}
                    size="sm"
                    btnlabel={handleValidateCodevalue(internationalise,'COMMON_SAVE')}
                    handleSave={handleSaveActivity}
                >
                    {activityForm}
                </LeadDialog>
            )}
    {(specificRolePermission?.isTaskManage && (taskDetails?.selectedCustomer || taskDetails?.senderEmail)) && (                    
                <Stack 
                className='icon-Container'
                padding = {isMobile ? "0px 0px": "0px 16px"}
                bgcolor={"#F4F9FE"}
                display="flex" 
                gap = {1}
                justifyContent="flex-start"
                flexDirection="row" 
            >
    <Tooltip title={handleValidateCodevalue(internationalise, "COMMON_SEND_NOTI_EMAIL")}>
                            <IconButton
                             onClick={() => handleOpenNotificationPopup(false,"TEMPLATE_CHANNEL_EMAIL")}
                             >
                            <MarkunreadIcon className='followup-icons'
                            />
                            </IconButton>
                        </Tooltip>          
                        <Tooltip title={handleValidateCodevalue(internationalise, "COMMON_SEND_WHATSAPP")}>
                            <IconButton
                             onClick={()=>handleOpenNotificationPopup(true,"TEMPLATE_CHANNEL_WHATSAPP")}
                             >
                            <WhatsAppIcon className='whatsapp-icon'
                            />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title={handleValidateCodevalue(internationalise, "COMMON_CALL")}>
                            <IconButton
                             onClick={() => {
                                if (isMobile && taskDetails?.selectedCustomer?.phone) {
                                  window.location.href = `tel:${taskDetails?.selectedCustomer?.phone}`;
                                  return;
                                }

                                if (telecallingDetails?.accountSid) {
                                  const result = startOutgoingCall({
                                    ClientId: currentUser?.client?.id,
                                    userId: currentUser?.userId,
                                    TaskId: taskId,
                                    phone: taskDetails?.selectedCustomer?.phone,
                                    title: handleValidateCodevalue(internationalise, "COMMON_NOTIFY_CUSTOMER"),
                                  });
                                  if (result?.blocked) {
                                    enqueueSnackbar(handleValidateCodevalue(internationalise, "TC_CALL_ALREADY_ACTIVE") || "A call is already in progress", { variant: "warning" });
                                  }
                                } else if (taskDetails?.selectedCustomer?.phone) {
                                  window.location.href = `tel:${taskDetails?.selectedCustomer?.phone}`;
                                }
                              }}
                             >
                            <CallIcon className='followup-icons'
                            />
                            </IconButton>
                        </Tooltip>
            </Stack>
    )}
                <Stack 
                className='icon-Container'
                padding = {isMobile ? "0px 0px": "0px 16px"}
                bgcolor={"#F4F9FE"}
                display="flex"
                justifyContent="flex-end"
                flexDirection="row" 
            >
    <Tooltip title={handleValidateCodevalue(internationalise, "NOTIFY_TOOLTIP_TITLE")}>
            <IconButton
            onClick={()=>handleOpenNotifyBox()}
            className='followup-icons'
        >
        <NotificationsIcon/>
        </IconButton>
    </Tooltip>
</Stack>
</StyledLeadContainer>
        </StyledLeadContainer>
    )}

    {activitiesTableData.length > 0 && (
           <DataGridTable
                    isCheckboxReq={false}
                        rowsToView={ROWS_TO_VIEW_IN_CHILD_TABLE}
                        height = {CHILD_DATAGRIDTABLE_HEIGHT}
                        isLead = {false}
                        showId = {false}
                        renderValuesOnCard={renderValuesOnCard}
                            handleOnClickCard = {handleCardClick}
                                columns = {activityColumns}
                                dataGridData = {activitiesTableData}
                             />

                        )}
                        {isOpenActivityPopup.open && (
                            <TextDetailDialog
                                open={isOpenActivityPopup.open}
                                onClose={() =>setIsOpenActivityPopup({ open: false, selectedCard: null })}
                                title={handleValidateCodevalue(internationalise, "TASK_ACTIVITY_NOTE")}
                                text={isOpenActivityPopup?.selectedCard?.note}
                            />
                        )}
</LeadAccordion>

{/* Subtasks Accordion - Rendered only for parent/root tasks once details are loaded */}
{Boolean(taskDetails?.id && !taskDetails?.parentTaskId) && (
    <LeadAccordion
        label={handleValidateCodevalue(internationalise, I18N_TASK_SUBTASKS) || 'Subtasks'}
        {...subtasksAccordion.accordionProps}
    ><StyledLeadContainer>
        <Stack
            padding="24px 24px 24px 0px"
            alignItems="center"
            display="flex"
            justifyContent = "center"
            gap={2}
            flexDirection="row"
        >
            {!isViewMode && (
                <Button
                    className="secondry-edit-btn"
                    variant="outlined"
                    onClick={handleCreateSubtask}
                >
                    {handleValidateCodevalue(internationalise, I18N_TASK_CREATE_SUBTASK)}
                </Button>
            )}
            <FormControlLabel
                control={
                    <Switch
                        checked={showOpenSubtasksOnly}
                        onChange={(e) => setShowOpenSubtasksOnly(e.target.checked)}
                        name="showOpenSubtasks"
                        color="primary"
                    />
                }
                label={handleValidateCodevalue(internationalise, 'COMMON_SHOW_ONLY_ACTIVE_TASKS')}
            />
        </Stack>
                       <Stack 
                className='icon-Container'
                padding = {isMobile ? "0px 0px": "0px 16px"}
                bgcolor={"#F4F9FE"}
                display="flex"
                justifyContent="flex-end"
                flexDirection="row" 
            >
    <Tooltip title={
        `${handleValidateCodevalue(internationalise, "COMMON_NOTIFY_TITLE")} 
        ${handleValidateCodevalue(internationalise, "ALL_SUB_TASKS_OWNERS")}`}
        >
            <IconButton
            onClick={()=>handleOpenNotifyBox("ALL_SUB_TASKS_OWNERS")}
            className='followup-icons'
        >
        <NotificationsIcon/>
        </IconButton>
    </Tooltip>
    
</Stack>
        </StyledLeadContainer>
        <DataGridTable
            columns={subtaskColumns}
            dataGridData={displayedSubtasks}
            isRequiredToolBar={false}
            isCheckboxReq={false}
            isInvoiceproduct={true}
            rowsToView={ROWS_TO_VIEW_IN_CHILD_TABLE}
            height={CHILD_DATAGRIDTABLE_HEIGHT}
        />
    </LeadAccordion>
)}

{/* Customer Details Accordion - Show only if customer exists */}
{taskDetails?.selectedCustomer && taskDetails?.customerDetails && (
    
    <LeadAccordion
        label={handleValidateCodevalue(internationalise, 'TASK_CUSTOMER_DETAILS')}
    >
        {/* Customer Basic Info */}
        <StyledLeadContainer>
          <Box>
  {isMobile ?
  <span>
    {taskDetails.customerDetails.id}
  </span>
  :
    <>
    <Typography variant="caption" color="text.secondary" className="tc-section-header">
        {handleValidateCodevalue(internationalise, 'CUST_EDIT_CUSTOMER_ID')}
    </Typography>
  <TextFiledWithLabel
    className='readonly edit-task-customer-id-input'
    onClick={handleViewCustomer(taskDetails.customerDetails.id)}
    label={handleValidateCodevalue(internationalise, 'CUST_EDIT_CUSTOMER_ID')}
    value={ taskDetails.customerDetails.id}      
/>
</>
}
</Box>


            {taskDetails.customerDetails.title && (
                <TextFiledWithLabel
                    label={handleValidateCodevalue(internationalise, 'COMMON_TITLE')}
                    value={handleValidateCodevalue(internationalise, taskDetails.customerDetails.title)}                    
                    disabled
                />
            )}
            <TextFiledWithLabel
                label={handleValidateCodevalue(internationalise, 'CUST_EDIT_FIRSTNAME')}
                value={taskDetails.customerDetails.firstName}
                disabled
            />
            <TextFiledWithLabel
                label={handleValidateCodevalue(internationalise, 'CUST_EDIT_LASTNAME')}
                value={taskDetails.customerDetails.lastName}
                disabled
            />
            <TextFiledWithLabel
                label={handleValidateCodevalue(internationalise, 'CUSTOMER_TOTAL_VALUE')}
                value={taskDetails.customerDetails.totalValue}
                disabled
            />
        </StyledLeadContainer>

        {/* Customer Products Table */}
        {taskDetails.customerDetails.products && 
         taskDetails.customerDetails.products.length > 0 && (
            <Box className="edit-task-customer-products-box">
                <Typography variant="subtitle1" className="edit-task-products-title">
                    {handleValidateCodevalue(internationalise, 'CUSTOMER_PRODUCTS')}
                </Typography>
                <DataGridTable
                showName='productName'
                showId={false}
                renderValuesOnCard={renderValuesOnCardIfCustomer}
                    rowsToView={ROWS_TO_VIEW_IN_CHILD_TABLE}
                    height = {CHILD_DATAGRIDTABLE_HEIGHT}
                    isCheckboxReq = {false}
                    columns={customerProductColumns}
                    dataGridData={taskDetails.customerDetails.products}
                    isRequiredToolBar={false}
                    hideFooter={true}
                />
            </Box>
        )}
    </LeadAccordion>
)}


                {/* Documents Section */}
                <DocumentManagement
                    entityType='taskId'
                    url={`${process.env.REACT_APP_BASE_URL}taskDocument`}
                    docType={docType}
                    isViewMode={isViewMode}
                    clientId={taskId}
                    onSuccess={() => setIsAuditAccordionExpanded(false)}
                />

                {/* Audit Logs Accordion */}
                {(specificRolePermission?.isAuditView && !isMobile) && (
                    <div>
                        <LeadAccordion
                            label={handleValidateCodevalue(internationalise, 'COMMON_AUDIT_LOGS')}
                            {...auditAccordion.accordionProps}
                        >
                            <AuditLogs 
                                label=""
                                isSearchRequired={false}
                                entityDetails={{ entityId: taskId, entity: 'TASKS_SIDEBAR_MENU' }}
                                module="Task"
                            />
                        </LeadAccordion>
                    </div>
                )}
            </Box>
            {/* Footer Buttons */}
            <CreateLeadFooter>
                <Stack alignItems="center" display={"flex"} flexWrap={isMobile ? "nowrap" : "wrap"} gap={isMobile ? "0px" : "5px"} justifyContent={"space-between"} flexDirection="row">
                    <Typography variant='h6'>
                        {`${handleValidateCodevalue(internationalise, initialTaskDetails?.parentTaskId ? 'SUBTASK_EDIT_TITLE' : 'TASK_EDIT_TITLE')} - ${taskId}`}
                    </Typography>
                    {isMobile &&
                    <>
                    <Button 
                            className="edit-primary btn-space"
                            variant="outlined"
                            onClick={goBack}
                        >
                            <ArrowBackIcon />
                        </Button>
                        <Button
                            className="edit-primary"
                            variant="outlined"
                            onClick={handleUpdateTask}
                        >
                            <CheckIcon />
                        </Button>
                        </>
                        }
                        { !isMobile &&
                        <>
                    <Button className='edit-primary edit-task-btn-back' variant="outlined" onClick={goBack}>
                        {handleValidateCodevalue(internationalise, 'COMMON_BACK')}
                    </Button>
                        </>}

                </Stack>
                <Stack direction="row" alignItems="center">
                    {/* Re-open Task Button - shown when task is closed or cancelled */}
                    {specificRolePermission?.isTaskManage && canReopenTask && (
                        <Tooltip title={handleValidateCodevalue(internationalise, "TASK_REOPEN_TOOLTIP")}>
                            <Button
                                className="secondry-edit-btn btn-space"
                                variant="outlined"
                                onClick={handleReopenTask}
                            >
                                {handleValidateCodevalue(internationalise, "TASK_REOPEN_BUTTON")}
                            </Button>
                        </Tooltip>
                    )}
                </Stack>
            </CreateLeadFooter>

            
{                            (isOpenNotificationDialog?.isOpen) && (
                                <SendNotification
                                    subject = {taskDetails?.description}
                                    open={isOpenNotificationDialog?.isOpen}
                                    title= {handleValidateCodevalue(internationalise,"COMMON_NOTIFY_CUSTOMER")}
                                    selectedDetails={isOpenNotificationDialog?.selectedDetails}
                                    setIsOpenNotificationDialog = {setIsOpenNotificationDialog}
                                    type = {"Customer"}
                                    entityType = {"Task"}
                                    ccEmailId={taskDetails?.ccEmail}
                                    toEmailId={[
                                    taskDetails?.customerDetails?.email,
                                    taskDetails?.senderEmail
                                    ]
                                    .filter(Boolean)
                                    .join(',')}
                                    handleSuccess={handleEmailSent}
                                    entityId={taskId} 
                                    isWhatsapp= {isOpenNotificationDialog?.isWhatsapp}
                                    channel={isOpenNotificationDialog?.channel} 
                                    whatsappNumber = {taskDetails?.selectedCustomer?.phone}
                                    phoneCountryCode = {taskDetails?.selectedCustomer?.phoneCountryCode}
                                />
                            )
                                                }

                        {openNotifyBox?.open && (
    <NotificationDialog
        url = {openNotifyBox?.url}
        open={openNotifyBox.open}
        ownerName={openNotifyBox.ownerName}
        destinationType="TASK"
        contextPayload={{
            destinationId: openNotifyBox.destinationId,
            receiverId: openNotifyBox.receiverId,
        }}
        onClose={handleCloseDialog}
        enqueueSnackbar={enqueueSnackbar}
        internationalise={internationalise}
        handleValidateCodevalue={handleValidateCodevalue}
    />
)}

{isOpenDialog?.customerDialog && (
    <LeadDialog
        open={isOpenDialog?.customerDialog}
        handleClose={handleCloseCreateCustomer}
        handleSave={handleSaveNewCustomer}
        title={handleValidateCodevalue(internationalise, 'CUST_CREATE')}
        btnlabel={handleValidateCodevalue(internationalise, 'COMMON_SAVE')}
        alternateBtnLabel={handleValidateCodevalue(internationalise, 'COMMON_CANCEL')}
        size="md"
    >
        <Box className="edit-task-create-customer-grid">
            {/* Row 1 */}
            <SelectBoxWithLabel
                select
                required={true}
                name="title"
                error={newCustomerDetail?.title ? false : customerRequiredValue?.title}
                value={newCustomerDetail?.title || ''}
                label={handleValidateCodevalue(internationalise, 'COMMON_TITLE')}
                optionMenuItem={commonTitles}
                handleOnChange={handleChangeNewCustomer}
            />
            <TextFiledWithLabel
                name="firstName"
                required={true}
                error={newCustomerDetail?.firstName ? false : customerRequiredValue?.firstName}
                label={handleValidateCodevalue(internationalise, 'CUST_EDIT_FIRSTNAME')}
                handleOnChange={handleChangeNewCustomer}
                value={newCustomerDetail?.firstName}
                className="edit-task-customer-field-full"
            />
            <TextFiledWithLabel
                name="lastName"
                required={true}
                error={newCustomerDetail?.lastName ? false : customerRequiredValue?.lastName}
                label={handleValidateCodevalue(internationalise, 'CUST_EDIT_LASTNAME')}
                handleOnChange={handleChangeNewCustomer}
                value={newCustomerDetail?.lastName}
                className="edit-task-customer-field-full"
            />
            {/* Row 2 */}
             <PhoneNumberField
                required={true}
                isDetailPage={true}
                isViewMode={isViewMode}
                name="phone"
                countryCodeName="phoneCountryCode"
                countryCode={newCustomerDetail?.phoneCountryCode || "+91"}
                value={newCustomerDetail?.phone}
                isRequired={customerRequiredValue?.phone || false}
                handleOnChange={handleChangeNewCustomer}
                />
            <CommonEmail
                required={true}
                isDetailPage={true}
                name="email"
                value={newCustomerDetail?.email}
                isRequired={customerRequiredValue?.email || false}
                handleOnChange={handleChangeNewCustomer}
                className="edit-task-customer-email-col"
            />
        </Box>
    </LeadDialog>
)}

{cascadeConfirm.open && (
    <BiztantuConfirmDialog
        open={cascadeConfirm.open}
        onClose={() => setCascadeConfirm(prev => ({ ...prev, open: false }))}
        onConfirm={handleCascadeConfirm}
        title={handleValidateCodevalue(internationalise, I18N_TASK_CLOSE_TITLE) || 'Close Subtasks'}
        size="sm"
        confirmBtnLabel={handleValidateCodevalue(internationalise, 'COMMON_YES')}
        cancelBtnLabel={handleValidateCodevalue(internationalise, 'COMMON_CANCEL')}
        message={
            (handleValidateCodevalue(internationalise, I18N_TASK_CLOSE_DESC) ||
                'Closing this task will also close {count} open subtask(s). Do you wish to proceed?')
                .replace('{count}', cascadeConfirm.openSubtaskCount)
        }
    />
)}

        </BiztantuLoader>
    );
}

export default EditTask;
